import React, {useRef, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {aiInterpApi} from './api'
import type {BulkImportResultDto} from './types'

interface Props { open: boolean; onClose: () => void; onComplete: () => void }

export const BulkImportModal: React.FC<Props> = ({open, onClose, onComplete}) => {
  const fileRef = useRef<HTMLInputElement>(null)
  const [file, setFile] = useState<File | null>(null)
  const [result, setResult] = useState<BulkImportResultDto | null>(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const reset = () => { setFile(null); setResult(null); setError(null); if (fileRef.current) fileRef.current.value = '' }
  const close = () => { reset(); onClose() }

  const upload = async () => {
    if (!file) return
    setBusy(true); setError(null); setResult(null)
    try {
      const r = await aiInterpApi.bulkImport(file)
      setResult(r)
      onComplete()
    } catch (e: any) { setError(String(e?.message ?? e)) }
    finally { setBusy(false) }
  }

  return (
    <Modal show={open} onHide={close} centered>
      <Modal.Header closeButton><Modal.Title>Bulk Import — AI Interpreters</Modal.Title></Modal.Header>
      <Modal.Body>
        <p className='text-muted'>Upload an .xlsx with columns: FirstName | LastName | Email | Languages</p>
        <label className='form-label' htmlFor='ai-interp-bulk-file'>XLSX file</label>
        <input
          id='ai-interp-bulk-file'
          ref={fileRef}
          type='file'
          accept='.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          className='form-control'
          onChange={e => setFile(e.target.files?.[0] ?? null)}
        />

        {result && (
          <div className='mt-3'>
            <div>Added: {result.added}</div>
            <div>Already present: {result.alreadyPresent}</div>
            <div>Skipped: {result.skipped}</div>
          </div>
        )}
        {error && <div className='text-danger mt-2' role='alert'>{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <button className='btn btn-secondary' onClick={close}>Close</button>
        <button className='btn btn-primary' disabled={!file || busy} onClick={upload}>
          {busy ? 'Uploading…' : 'Upload'}
        </button>
      </Modal.Footer>
    </Modal>
  )
}
